import { render, staticRenderFns } from "./textarea-overflow.vue?vue&type=template&id=723c8c69&"
import script from "./textarea-overflow.vue?vue&type=script&lang=js&"
export * from "./textarea-overflow.vue?vue&type=script&lang=js&"
import style0 from "./textarea-overflow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports